import type {ResourceChangeRealtimeHandler} from "../../../shared/realtime/resource-change-realtime.types";
import type {output} from "zod";

import {SupplierRealtimeChange} from "@project/sdk/realtime";

import {supplierKeys} from "../supplier-keys";

type SupplierRealtimeChangeEvent = output<typeof SupplierRealtimeChange>;

export const suppliersRealtimeHandler: ResourceChangeRealtimeHandler<SupplierRealtimeChangeEvent> =
  {
    resource: "engineering.suppliers",
    queryKey: supplierKeys.all,
    eventSchema: SupplierRealtimeChange,
    async handleEvent(event, queryClient) {
      if (event.change === "CREATED") {
        await queryClient.invalidateQueries({queryKey: supplierKeys.lists()});
        return;
      }
      await queryClient.invalidateQueries({queryKey: supplierKeys.all});
    },
  };
